import { useEffect } from "react";
import Button from "@/components/Button";
import {
  compactGlobalToolbarBorderlessIconStyle,
  globalToolbarIconButtonWrapClassName
} from "@/components/Button/globalAddButtonFilledStyle";
import { compactGlobalNavbarIconBoxClassName } from "@/components/TopActionBar/compactNavbarChrome";
import { isModifierShortcut, matchesModifierShortcutKey } from "@/lib/keyboardShortcuts";
import classNames from "classnames";

export interface ToolbarQuickSearchButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  testId?: string;
}

export default function ToolbarQuickSearchButton({
  onClick,
  disabled = false,
  testId = "quick-search-button"
}: ToolbarQuickSearchButtonProps) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!isModifierShortcut(event) || !matchesModifierShortcutKey(event, "k")) return;
      event.preventDefault();
      if (!disabled && onClick) {
        onClick();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClick, disabled]);

  return (
    <span className={classNames(globalToolbarIconButtonWrapClassName, compactGlobalNavbarIconBoxClassName)}>
      <Button
        variant="outlined"
        icon="search"
        iconWeight={800}
        ariaLabel="Find"
        testId={testId}
        onClick={onClick}
        disabled={disabled}
        style={compactGlobalToolbarBorderlessIconStyle}
      />
    </span>
  );
}
